import { createContext } from 'react';
/* 
  This context must be imported using the client-site-chrome-ui alias  
  i.e. client-site-chrome-ui/context/DynamicContext/context
  to ensure it is always resolved from the same location by yarn PNP
  otherwise an error can be thrown that the context is not defined 
  i.e.'useSiteChromeDynamicContext must be used within a SiteChromeDynamicContextProvider'
*/

export var SiteChromeDynamicContext = /*#__PURE__*/createContext(undefined);